import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { GetCacheKey } from '../../services/common/utils';
import Loadingcomponent from '../loader/loadingcomponent';
import { redirecturl } from '../../services/common/redirect';
import useAppExclusive from '../../hooks/useAppExclusive';
import ExclusiveModal from '../common/exclusive-modal';
import { MAKE_SMART_PAY_EXCLUSIVE } from '../../services/common/Constants';
import {SmartPayCard as SmartPayCardSkeleton} from '../loader/skeletons'

const SmartPayCard = ({ psmItem }) => {
  const navigate = useNavigate();
  const [showsmartpay,setshowsmartpay]= useState(false);

  const {show, toggleModal} = useAppExclusive();

  const { data: { data } = {}, isLoading, } = useQuery(
    [
      GetCacheKey(psmItem?.uniqueid),
      psmItem?.method,
      JSON.parse(psmItem?.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess:(resp)=>{
        if(resp.data.status == "0")
         setshowsmartpay(true)
        else
        setshowsmartpay(false)
         
      }
    }
  );

  const handleRedirect = (url) => {
    //alert(MAKE_SMART_PAY_EXCLUSIVE)
    if(MAKE_SMART_PAY_EXCLUSIVE == "true"){
      toggleModal();
    }else{
      if (url) {
        redirecturl(url, navigate);
      }
    }
  };

  if (isLoading) {
    // return <Loadingcomponent />;
    return <SmartPayCardSkeleton />;
  }

  return (
    <>
    {
    showsmartpay == true ? (
    <div class="mb-3">
      <div class="white_card dashboard_card mt-3">
        <div class="flex_grp_between ">
          <div class="balance_section_info">
            <label>{data?.response?.title}</label>
            <p style={{ marginBottom: '0px' }}>{data?.response?.description}</p>
          </div>
          <div class="balance_section_action">
            <button
              onClick={() => handleRedirect(data?.response?.redirecturl)}
              class="custom_btn custom_btn_sm custom_btn_primary"
            >
              {data?.response?.buttontext}
            </button>
          </div>
        </div>
      </div>
      </div>
    ) : <></>
    }

    <ExclusiveModal show={show} toggleModal={toggleModal} deeplinktext='smartPay' />
  </>
  );
};

export default SmartPayCard;
